import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';
import { isStandardVariant } from 'helpers/iconSizes';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const Lightning = ({ className = '', svgSize = ICON_SIZES.MD }) => {
  const { theme } = useContext(BrandContext);
  const isStandardVariantIcon = isStandardVariant(svgSize);

  if (isStandardVariantIcon) {
    return (
      <svg
        width={svgSize}
        height={svgSize}
        className={className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.43853 17.9406L18.3327 3L16.4986 11.8649C16.413 12.2787 16.7289 12.6667 17.1514 12.6667H24.0312C24.5746 12.6667 24.8897 13.2819 24.5722 13.7229L13.3327 29.3333L14.8747 19.7728C14.9401 19.3675 14.6271 19 14.2165 19H7.9772C7.43197 19 7.11729 18.3811 7.43853 17.9406Z"
          fill={theme.icon.fill}
        />
        <path
          d="M17.7951 2.60793C17.98 2.35434 18.3168 2.26406 18.6037 2.39114C18.8903 2.51838 19.05 2.82818 18.9865 3.13528L17.1526 12.0005H24.0324C25.1189 12.0009 25.7493 13.231 25.1145 14.1128L13.8752 29.7232C13.6947 29.9738 13.3648 30.0675 13.0793 29.9497C12.7938 29.8317 12.6271 29.533 12.676 29.228L14.218 19.6675H7.97873C6.8884 19.6675 6.25853 18.4295 6.90061 17.5484L17.7951 2.60793ZM7.97873 18.3335H14.218C15.0387 18.3339 15.665 19.0691 15.5344 19.8794L14.4416 26.6538L24.0324 13.3335H17.1526C16.3077 13.3335 15.6759 12.5573 15.8469 11.73L17.0559 5.88332L7.97873 18.3335Z"
          fill={theme.icon.stroke}
        />
      </svg>
    );
  }

  return (
    <svg
      width={svgSize}
      height={svgSize}
      className={className}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.373 25.7506L32.0838 5.25L13.019 31.396C12.4569 32.1669 13.0076 33.25 13.9617 33.25H24.8806C25.599 33.25 26.1467 33.8931 26.0323 34.6024L23.3338 51.3333L33.6492 29.0739C34.0075 28.3007 33.4429 27.4167 32.5906 27.4167H23.4274C22.5709 27.4167 22.0064 26.5246 22.373 25.7506Z"
        fill={theme.icon.fill}
      />
      <path
        d="M31.3767 4.7342C31.6195 4.40172 32.0617 4.28324 32.4382 4.45002C32.8145 4.61697 33.0234 5.02441 32.9402 5.42756L29.7302 20.9403C29.6927 21.1213 29.8315 21.2918 30.0163 21.2918H42.0554C43.7193 21.292 44.6846 23.1757 43.7126 24.5262L24.0437 51.8445C23.8066 52.1738 23.3737 52.2964 22.9988 52.1414C22.6242 51.9863 22.4051 51.5944 22.4695 51.1942L25.1677 34.4627C25.1959 34.2858 25.0597 34.1252 24.8806 34.1248H13.9616C12.292 34.1248 11.328 32.2299 12.3113 30.8807L31.3767 4.7342ZM13.7253 31.911C13.5848 32.1037 13.7231 32.3748 13.9616 32.3748H24.8806C26.1374 32.3752 27.0961 33.5011 26.8962 34.742L24.7859 47.8172L42.2927 23.5037C42.4312 23.3109 42.2929 23.042 42.0554 23.0418H30.0163C28.7224 23.0418 27.7552 21.8528 28.0173 20.5858L30.406 9.03498L13.7253 31.911Z"
        fill={theme.icon.stroke}
      />
    </svg>
  );
};

Lightning.propTypes = {
  className: PropTypes.string,
  svgSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Lightning;
